//  View More button 
 
$(document).ready(function () {
  var list = $(".bundle-best-seller-row .bundle-best-seller-item");
  var numToShow = 8;
  var button = $("#next");
  var numInList = list.length;
  list.hide();
  if (numInList > numToShow) {
    button.show();
  }
  list.slice(0, numToShow).show();

  button.click(function () {
    var showing = list.filter(":visible").length;
    list.slice(showing - 1, showing + numToShow).fadeIn();
    var nowShowing = list.filter(":visible").length;
    if (nowShowing >= numInList) {
      button.hide();
    }
  });
});

$(document).ready(function() {
  $('label.color-field').click(function() {
    $('label.color-field').removeClass('color-active');
    $(this).addClass('color-active');
  });
});
$(document).ready(function() {
  $('label.bundle-field').click(function() {
    $('label.bundle-field').removeClass('bundle-active');
    $(this).addClass('bundle-active');
  });
});
$(document).ready(function() {
  $('label.storage-field').click(function() {
    $('label.storage-field').removeClass('storage-active');
    $(this).addClass('storage-active');
  });
});


// You may also like section ADD JS
$(document).ready(function() {
  $(".btn-add").click(function() {
        var ID = $(this).attr('value'); 
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: ID,
          quantity: 1
        },
          dataType: 'json', 
         success: function (data) {
           jQuery.getJSON('/cart.js', function(cart) {
              setTimeout(function(){
                window.location.href= '/cart';
              },300);
                });
           
             } 
         });
 
  });

});

// Popup varinat compare 

$('.bundle-peek-link').click(function(e) {
  e.preventDefault();
   var swatch_val = $(this).attr('product_id');
  $(".peek-inside-popup-wrapper").each(function(){
     var mediaValue = $(this).attr('popup_id');
    //  var mediaval = document.querySelectorAll(".product-slider .product-box-item").value;

      if(swatch_val == mediaValue){
        $(this).css({"opacity": "1", "width": "100%" , "height": "100%", "display": "flex"});
      } else {
         $(this).css({"opacity": "0", "width": "0%" , "height": "0%", "display": "none"});
      }
   
  });
});

$('.peek-inside-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  prevArrow: "<div class='arrow-prev'><img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/6474bc091e02f3f36a76e941/647f9825d0d4bfe668c1ede2_prev.svg'></div>",
  nextArrow: "<div class='arrow-next'><img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/6474bc091e02f3f36a76e941/647f9825f2ef1e7c884f6056_next.svg'></div>",
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
























